<div class="col px-0 pt-1 navigation"
     [ngStyle]="user && user.faculty && user.faculty.color?
     {backgroundColor: user.faculty.color} :  {backgroundColor: ' rgba(0, 0, 0, 0.23)'} ">
  <button class="ghost"
          [matTooltip]="'tuke.sk'"
          matTooltipPosition="right">
    <a href="https://www.tuke.sk/wps/portal/tuke/university/vnutorny-system-kvality" target="_blank">
      <img src="assets/images/tuke_logo_light.png" alt="TUKE logo" width="30">
    </a>
  </button>
  <button class="ghost"
          [matTooltip]="name ? ('navigation.buttons.logged_user.tooltip' |translate: {uuid: name}) : ''"
          matTooltipPosition="right">
    <i class="fas fa-user"></i>
  </button>
  <button class="ghost"
          [matTooltip]="'navigation.buttons.dashboard.tooltip' |translate"
          matTooltipPosition="right"
          [routerLink]="'dashboard'"
          [queryParamsHandling]="'preserve'">
    <i class="fas fa-desktop"></i>
  </button>
  <!--  TODO when enabling translations uncomment-->
  <!--  <button class="ghost"-->
  <!--          [matTooltip]="'common.tooltip.change_language' |translate"-->
  <!--          matTooltipPosition="right"-->
  <!--          (click)="changeLanguage()">-->
  <!--    <i class="fas fa-globe-europe"></i>-->
  <!--  </button>-->
  <button class="ghost"
          [matTooltip]="'navigation.buttons.logout.tooltip' |translate"
          matTooltipPosition="right"
          (click)="logout()">
    <i class="fas fa-sign-out-alt"></i>
  </button>
</div>
